import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

const SimplebarReactClient = ({ children, ...options }) => {
  return <SimpleBar {...options}>{children}</SimpleBar>;
};

export default SimplebarReactClient;
